import {
  GET_ORGANIZATION_AGENTS_ERROR,
  GET_ORGANIZATION_AGENTS_START,
  GET_ORGANIZATION_AGENTS_SUCCESS,
} from 'constants/action-types/organizations/getAgents';

export default (state, { type, payload }) => {
  switch (type) {
    case GET_ORGANIZATION_AGENTS_START:
      return {
        ...state,
        organizationAgents: {
          ...state.organizationAgents,
          loading: true,
          error: null,
        },
      };
    case GET_ORGANIZATION_AGENTS_SUCCESS:
      return {
        ...state,
        organizationAgents: {
          ...state.organizationAgents,
          loading: false,
          items: payload.data,
          meta: payload.meta,
        },
      };
    case GET_ORGANIZATION_AGENTS_ERROR:
      return {
        ...state,
        organizationAgents: {
          ...state.organizationAgents,
          loading: false,
          error: payload,
        },
      };
    default:
      return null;
  }
};
